// Extract video ID from YouTube URL
export const extractVideoId = (url) => {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
    /youtube\.com\/watch\?.*v=([^&\n?#]+)/,
  ];
  
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) {
      return match[1];
    }
  }
  
  return null;
};

// Get thumbnail URL from video ID
export const getThumbnailUrl = (videoId, quality = 'maxresdefault') => {
  if (!videoId) return null;
  
  // Available qualities: maxresdefault, hqdefault, mqdefault, sddefault, default
  return `https://img.youtube.com/vi/${videoId}/${quality}.jpg`;
};

// Validate YouTube URL
export const isValidYouTubeUrl = (url) => {
  const videoId = extractVideoId(url);
  return videoId !== null;
};

// Get multiple thumbnail qualities
export const getAllThumbnailQualities = (videoId) => {
  if (!videoId) return {};
  
  return {
    maxres: getThumbnailUrl(videoId, 'maxresdefault'),
    high: getThumbnailUrl(videoId, 'hqdefault'),
    medium: getThumbnailUrl(videoId, 'mqdefault'),
    standard: getThumbnailUrl(videoId, 'sddefault'),
    default: getThumbnailUrl(videoId, 'default'),
  };
};
